__turbopack_context__.v({
  "action_area": "Form-module-scss-module__XwL0fG__action_area",
  "children_slot": "Form-module-scss-module__XwL0fG__children_slot",
  "complete": "Form-module-scss-module__XwL0fG__complete",
  "complete_message": "Form-module-scss-module__XwL0fG__complete_message",
  "field_item": "Form-module-scss-module__XwL0fG__field_item",
  "form_scroll": "Form-module-scss-module__XwL0fG__form_scroll",
  "main": "Form-module-scss-module__XwL0fG__main",
  "root": "Form-module-scss-module__XwL0fG__root",
  "submit_button": "Form-module-scss-module__XwL0fG__submit_button",
});
